import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { vm } from '@/main'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppComponent',
  setup(__props) {

const PartnerModule = () => import('Partner')
const StreamerModule = () => import('Streamer')
const AuthModule = () => import('Auth')
const WidgetModule = () => import('Widget/components/Widget')
const PanelModule = () => import('views/Panel')
const CreativePreviewModule = () => import('views/CreativePreview')
const EmailVerificationModule = () => import('views/EmailVerification')
const PublicCampaignAnalyticsModule = () => import('views/PublicCampaignAnalytics')

const showEmailVerification = computed(() => vm.$route.name === 'streamer-email-verification')
const showWidgetModule = computed(() => vm.$route.name === 'widget-page')
const showPanelModule = computed(() => vm.$route.name === 'panel-page')
const showCreativePreviewModule = computed(() => vm.$route.name === 'creative-preview')
const showPublicCampaignAnalyticsModule = computed(() => vm.$route.name === 'public-campaign-analytics')
const showStreamerModule = computed(() => vm.$store.getters['auth/role'] === 'streamer' && vm.$store.getters['auth/isFilled'])
const showPartnerModule = computed(() => vm.$store.getters['auth/role'] === 'partner')

const module = computed(() => {
  if (showEmailVerification.value) return EmailVerificationModule
  if (showWidgetModule.value) return WidgetModule
  if (showPanelModule.value) return PanelModule
  if (showCreativePreviewModule.value) return CreativePreviewModule
  if (showPublicCampaignAnalyticsModule.value) return PublicCampaignAnalyticsModule
  if (showStreamerModule.value) return StreamerModule
  if (showPartnerModule.value) return PartnerModule
  return AuthModule
})

return { __sfc: true,PartnerModule, StreamerModule, AuthModule, WidgetModule, PanelModule, CreativePreviewModule, EmailVerificationModule, PublicCampaignAnalyticsModule, showEmailVerification, showWidgetModule, showPanelModule, showCreativePreviewModule, showPublicCampaignAnalyticsModule, showStreamerModule, showPartnerModule, module }
}

})